import React, { Component } from 'react';
import { connect } from 'react-redux';

import Organization from './OrganizationBlock';
import AlphabeticView from './alphabetic-view/AlphabeticView';


class ParticipantsPanel extends Component {
  render() {
    let container = null;
    if (this.props.byEducation) {
      container = <Organization
        keyData={this.props.params.filter ? this.props.params.filter : 'all'} filter={this.props.params.filter}
        organizationData={this.props.participants.byEducation}
      />;
    } else {
      const participantData = this.props.participants.byLastName;

      container = Object.keys(participantData).sort().map(literal => (
        <AlphabeticView
          key={literal} literal={literal} filter={this.props.params.filter}
          participants={participantData[literal]}
        />
      ));
    }
    return (
      <div className='participants__container'>
        {container}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  byEducation: state.participants.byEducation,
  participants: state.participants.participants
});

export default connect(mapStateToProps)(ParticipantsPanel);



// WEBPACK FOOTER //
// ./src/participants-page/blocks/ParticipantsPanel.js